import { Display } from '../Display/Display';

import WebFileSearchDisplay from './Web';
import MobileFileSearchDisplay from './Mobile';
const FileSearchDisplay = (props) => {
    return (
        <>
            <Display show={props.side === 'web'}>
                <WebFileSearchDisplay {...props}></WebFileSearchDisplay>
            </Display>
            <Display show={props.side === 'mobile'}>
                <MobileFileSearchDisplay {...props}></MobileFileSearchDisplay>
            </Display>
        </>
    );
};
export default FileSearchDisplay;
